import React from "react";

import ContentCore from "../../../core/workingContent";

const TaskReturnReceiverUI = () => {
  return (
    <ContentCore />
  )
}

export default TaskReturnReceiverUI